<template>

<!-- <template v-for="(row, key) in rows" :key="key">
    {{ incrementIndex(key) }} {{ row[0] }} 
</template> -->

<!-- {{ meta }} -->


<!-- {{ row }} -->
<!-- {{ row.species.name }} {{ row.ref_location_m8rb }} {{ index }} {{ key }} -->
  <!--Должно быть как-то так - но почему ид строк невытаскиваются? <div v-if="row.species.name[key] != row.species.name[key-1]">{{ row.species.name }}</div> <div>{{ row.ref_location_m8rb }}</div> <div>{{ row.species.name[key] }} {{ row.species.name[key+1] }} {{ row.species.name }}</div> -->

<!-- <div v-for="col in this.$store.state.metaPrint.columns" :key="col">
          <base-geo-cell v-bind="{mode:'view', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
</div> -->

<!-- <v-list-item v-for="(row, index) in rows" :key="row.id"

:title=row.species.name
    :subtitle=row.ref_location_m8rb

></v-list-item> -->



<!-- <v-list v-for="(row, index) in rows" :key="row.id" :opened=true>
  <v-list-group :value=row.species.name>
    <v-list-item :value = row.ref_location_m8rb></v-list-item>
  </v-list-group>
  </v-list> -->

<!-- <div v-for="row in rows" :key="row">

  <div align="right">{{row.mainstorage.name}} {{row.localcollnumber}}</div>

<div>&nbsp;</div>

  <strong>{{row.store}}</strong>
  <div v-for="srow in row.species.rows.slice(1)" :key="srow"> {{ srow.species.name }} </div>

<div>&nbsp;</div>

<point-widget v-bind="{mode:'view'}" v-model="row.coordinates"/>
<div v-if="row.alt">El.: {{row.alt}} m a.s.l.</div>
{{row.location}} <br>
Leg.: <date-widget v-bind="{mode:'view'}" v-model="row.legdate" /> {{row.legname2}} <span v-if="row.legnum"> ({{row.legnum}}) </span><br>
Det.: <date-widget v-bind="{mode:'view'}" v-model="row.species.rows[0].detdate" /> {{row.detprint}} <br>
<div align="right">LID: {{row.linkid}}</div>
<div>- - - - - - - ✂ - - - - - - - </div>
<p>&nbsp;</p>



</div> -->
                <!-- <div class="my-2">  
        <div v-for="col in this.$store.state.metaPrint.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'view', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
        </div>
      </div>
      <div v-for="col in this.$store.state.metaPrint.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'location'" v-bind="{mode:'view', column:col, initValue:row[col.fieldname], meta:meta, rowobject:row}" v-model="row[col.fieldname]"/>
      </div> -->



</template>
<script>
import PointWidget from '@/components/widgets/PointWidget.vue';
import DateWidget from '@/components/widgets/DateWidget.vue';
export default {
    name: 'list-standard-print-page',
    components: {
      PointWidget,
      DateWidget,

    },
    props:['meta', 'rows'],
    data(){ 
        return {
        }
    },

    mounted(){
        // this.getReplacedData()
    },

    methods: {

    //   incrementIndex(key) {
    //     return key + 1;
    // },

      // getReplacedData(){
      //   this.rows.forEach(key => {
      //   //  console.log(key, this.filters[key]);

      //       if (this.rows[key].species.id == this.rows[key-1].species.id) {
      //         this.rows[key].species.name = "100500";
      //       }

      //     });

      // },

    },


  


}
</script>